import Main from '@/layout/main.vue'
const routes = [
    {
        path: '/earnest',
        name: 'earnest',
        meta: { title: '保证金管理' },
        redirect: '/earnest/lists',
        component: Main,
        children: [
            {
                path: '/earnest/lists',
                name: 'earnest_lists',
                meta: {
                    title: '保证金列表',
                    parentPath: '/earnest',
                    icon: 'icon_ziti_store',
                    permission: ['view']
                },
                component: () => import('@/views/earnest/index.vue')
            },
            {
                path: '/earnest/detail',
                name: 'earnest_detail',
                meta: {
                    title: '保证金明细',
                    parentPath: '/earnest',
                    icon: 'icon_ziti_store',
                    permission: ['view']
                },
                component: () => import('@/views/earnest/detail.vue')
            }
        ]
    }
]

export default routes
